import { isSockItem } from './wardrobe-stats.js';

function allItems(state) {
  return (state.locations || []).flatMap(location => (location.zones || []).flatMap(zone => (zone.items || []).map(item => ({ item, location, zone }))));
}

export function getAchievementSummary(state, parties = []) {
  const entries = allItems(state);
  const wardrobeEntries = entries.filter(entry => entry.location.type !== 'surrounding' && entry.location.type !== 'intake_pile' && entry.location.name !== 'Unsorted Intake');
  const surroundingEntries = entries.filter(entry => entry.location.type === 'surrounding');
  const trackedSurroundings = surroundingEntries.filter(entry => entry.item.surrounding?.tracked);
  const fits = state.mirror?.ootdHistory || [];
  const unlocked = [
    { id: 'first-capture', title: 'First reflection', detail: 'Capture something worth remembering.', unlocked: entries.length > 0 },
    { id: 'sorted-start', title: 'A place for it', detail: 'Move your first record out of Intake.', unlocked: wardrobeEntries.length > 0 },
    { id: 'surrounding-depth', title: 'Depth added', detail: 'Record a room or surrounding.', unlocked: surroundingEntries.length > 0 },
    { id: 'fit-memory', title: 'Fit memory', detail: 'Save a fit to your visual history.', unlocked: fits.length > 0 },
    { id: 'care-signal', title: 'Care signal', detail: 'Track a surrounding record for attention.', unlocked: trackedSurroundings.length > 0 },
    { id: 'rotation-builder', title: 'Rotation builder', detail: 'Keep five records in a real closet.', unlocked: wardrobeEntries.length >= 5 },
    { id: 'party-ready', title: 'Party ready', detail: 'Connect a private sync party.', unlocked: parties.length > 0 },
  ];
  const unlockedCount = unlocked.filter(entry => entry.unlocked).length;
  return {
    achievements: unlocked,
    unlockedCount,
    total: unlocked.length,
    referralUnlocked: unlockedCount >= 3,
    counts: {
      captures: entries.length,
      sorted: wardrobeEntries.length,
      surrounding: surroundingEntries.length,
      tracked: trackedSurroundings.length,
      fits: fits.length,
      socks: entries.filter(entry => isSockItem(entry.item)).length,
    },
  };
}

export function referralUrl(code = '') {
  if (typeof window === 'undefined') return import.meta.env.BASE_URL;
  const query = String(code || '').trim();
  return `${window.location.origin}${import.meta.env.BASE_URL}${query ? `?ref=${encodeURIComponent(query)}` : ''}`;
}
